/* DROP VAULT — overlay shown when the visitor enters The Vault room.
   Zero-touch to the engine: polls Shop.state.room. */
(function(){
  var shown = false, el = null;
  function build(){
    el = document.createElement('div');
    el.id = 'vault-overlay';
    el.innerHTML =
      '<div style="position:fixed;inset:0;display:flex;align-items:center;justify-content:center;z-index:60;pointer-events:none">' +
      '<div style="pointer-events:auto;background:rgba(8,10,22,.92);border:1px solid #2962FF;border-radius:14px;max-width:440px;width:calc(100% - 48px);padding:34px 34px 28px;text-align:center;box-shadow:0 30px 80px rgba(0,0,0,.6)">' +
      '<div style="font-size:34px">🔒</div>' +
      '<div style="font-family:Georgia,serif;font-size:30px;color:#F0F4F8;margin-top:10px">The Vault</div>' +
      '<div style="font-family:ui-monospace,Consolas,monospace;font-size:12px;letter-spacing:.14em;color:#3DFFC0;margin-top:10px">DROP 001 · THE NEXT WORK SLEEPS HERE</div>' +
      '<p style="color:#aab4d4;font-size:14px;line-height:1.65;margin:16px 0 22px">One work. One window. Then the edition is sealed forever. The waitlist walks in 24 hours before the public.</p>' +
      '<a href="/pages/drop-001" style="display:block;background:#2962FF;color:#fff;text-decoration:none;border-radius:999px;padding:13px 18px;font-family:ui-monospace,Consolas,monospace;font-size:13px;letter-spacing:.12em">JOIN THE WAITLIST</a>' +
      '<button id="vault-close" style="margin-top:14px;background:none;border:0;color:#5b6588;font-size:12px;cursor:pointer">keep wandering</button>' +
      '</div></div>';
    document.body.appendChild(el);
    document.getElementById('vault-close').onclick = function(){ el.style.display='none'; };
  }
  setInterval(function(){
    try {
      var room = window.Shop && window.Shop.state && window.Shop.state.room;
      if (room === 'vault') {
        if (!el) build();
        if (!shown) { el.style.display = 'block'; shown = true; }
      } else { shown = false; if (el) el.style.display = 'none'; }
    } catch(e){}
  }, 600);
})();

/* Keep the rooms-overlay headline honest forever: count from ROOM_ORDER. */
(function(){
  function upd(){
    try {
      var h = document.getElementById('rooms-count-head');
      if (h && window.ROOM_ORDER) h.textContent = window.ROOM_ORDER.length + '+ rooms and counting.';
    } catch(e){}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', upd); else upd();
})();
